import { usePTVNAuthentication } from '@ptvn-react/authentication';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ExtendedUserInformation } from '../models/User';

const useRedirect = () => {
  const { userInformation } = usePTVNAuthentication<ExtendedUserInformation>();
  const redirectUrl = localStorage.getItem('redirect');

  const handleStoreRedirectLink = useCallback(() => {
    if (window.location.search.includes('origin=mail') && !userInformation) {
      localStorage.setItem('redirect', JSON.stringify(window.location.pathname));
    }
  }, []);

  return { redirectUrl, handleStoreRedirectLink };
};

export default useRedirect;
